module.exports = __webpack_public_path__ + "static/media/aia.d5c70b71.svg";